import React, {useState} from "react";
import { Button, message, Popconfirm, Select } from "antd";
import { apiCall } from "../../utils/Api";
import { useSession } from "../../utils/Session";

export default function ResendOrder(props) {

    const {bookorder_id} = props; 
    const [session, setSession] = useSession();
    const [sent, setSent] = useState(false)
    const stores = window.sitesettings.stores;
    const [selectedStore, setSelectedStore] = useState();

    
    const resendOrder = () =>{

        const args = { bookorder_id: bookorder_id };

        if (selectedStore) {
            args.override_contact_id = selectedStore;
        }

        apiCall("orders/resend", args, (_status, _result) =>{
            if(_status){
                message.success("Order resent successfully.")
                setSent(true);
            } else {
                message.error("There was an error.")
            }
        });
        setSelectedStore();
    }

    return (
        <Popconfirm 
            placement="left" 
            title={
                stores.length > 1 ? (
                    <div style={{ position: "relative" }}>
                        <div>Select Store to resend to:</div>
                        <Select
                            style={{ width: 200 }}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            options={stores.map((map) => ({
                                value: map.cid,
                                label: map.name,
                            }))}
                            defaultValue={session.store_id}
                            onChange={(value) => setSelectedStore(value)} 
                        />
                    </div>
                ) : (
                    <>
                        <div>Resend Order?</div>
                    </>
                )
            }
            onConfirm={() => resendOrder()} 
            okText="Yes" 
            cancelText="No"
        >
            <Button type="primary" size="small">
                <small>{!sent ? "Resend" : "Resent!"}</small>
            </Button>
        </Popconfirm>
    )
}